// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"20":"css/admin-app.6824","1349":"css/app.6824"}[chunkId] + ".css";
};